"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bytesToFormattedString = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

/**
 * Converts bytes into a properly formatted, human readable string.
 * Example: 10485760 becomes '10 MB'
 * @param {number} bytes A numeric value.
 */
var bytesToFormattedString = function bytesToFormattedString(bytes) {
  var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];

  if (isNaN(bytes)) {
    throw new Error('Invalid variable passed to bytesToFormattedString()\nExpected type number, instead got type', (0, _typeof2["default"])(bytes));
  }

  if (bytes === 0) {
    return '0 Byte';
  }

  var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
  var j = i >= sizes.length ? sizes.length - 1 : i; // handle larger numbers

  return Math.round(bytes / Math.pow(1024, j), 2) + ' ' + sizes[j];
};

exports.bytesToFormattedString = bytesToFormattedString;